import { Suspense, createContext, useContext } from "solid-js";
import type { Component, JSXElement } from "solid-js";
import { FatalStartupErrorScreen } from "./components/FatalStartupErrorScreen";
import { type Wire, defaultWire } from "./definition";
import { newWire, validateWire } from "./factory";

export const WireContext = createContext(defaultWire);

// useWire provides access to dependencies, global state, and the ability to
// interact with domains/business-logic. This function must be called from
// within a SolidJS context established by the application.
export const useWire = (): Wire => {
  const wire = useContext(WireContext) as Wire;
  if (!wire) {
    throw new Error("useWire must be used within a Store.Provider");
  }
  return wire;
};

// WireProvider provides access to dependencies, global state, and the ability
// to interact with domains/business-logic.
export const WireProvider: Component<{
  children: JSXElement;
}> = (props) => {
  const wire = newWire();
  try {
    validateWire(wire);
  } catch (e: unknown) {
    return FatalStartupErrorScreen(e);
  }
  return (
    <Suspense>
      {/* Placing the resource here so that it triggers a suspense boundary, it won't render anything since it's null */}
      <WireContext.Provider value={wire}>{props.children}</WireContext.Provider>
    </Suspense>
  );
};
